import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type ZebraMachine } from "@packsize/schemas/machines";

import { getZebraMachine } from "@/api/machines/zebra-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { ZEBRA_MACHINES_QUERY_KEY } from "./query-keys";

type UseZebraMachineQueryOptions = UseMachinesQueryOptions<ZebraMachine | null, Error>;

export const getZebraMachineQuery = (machineId: string | null | undefined, options?: UseZebraMachineQueryOptions) => ({
	queryKey: [...ZEBRA_MACHINES_QUERY_KEY, { machineId }],
	queryFn: () => getZebraMachine(machineId || ""),
	...options,
	enabled: Boolean(machineId) && (options?.enabled ?? true),
});

export const useZebraMachine = (
	machineId: string | null | undefined,
	options?: UseZebraMachineQueryOptions,
): UseQueryResult<ZebraMachine | null, Error> => {
	return useQuery<ZebraMachine | null, Error>(getZebraMachineQuery(machineId, options));
};
